import { TFunction } from 'i18next'
import { Header } from 'routes/Transits/Table/config'

export default function getTraderTableHeaders(t: TFunction): Header[] {
  return [
    {
      title: t('traders.name'),
      accessor: 'name',
      className: 'fixed-width-lg',
    },
    {
      title: t('traders.identificationNumber'),
      accessor: 'identificationNumber',
      className: 'fixed-width-md',
    },
    {
      title: t('traders.address'),
      accessor: 'address',
    },
    {
      title: t('traders.contactPerson'),
      accessor: 'contactPerson',
    },
    {
      title: t('traders.lastUsedAt'),
      accessor: 'lastUsedAt',
      className: 'fixed-width-sm-l',
    },
    {
      title: '',
      accessor: 'actions',
      className: 'fixed-width-sm-l',
    },
  ]
}
